module.exports = __webpack_public_path__ + "static/pizza200_1-b9727f826bf89c1f87edcf988d84d967.png";